module.exports = __webpack_public_path__ + "68ad3695daff794b2732cfc2482ea821.woff2";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/SuisseIntlSemiBold.woff2
// module id = 1042
// module chunks = 0